export const S3_ENDPOINT = "https://d27i75siv2q3xq.cloudfront.net";